import type { UUID } from '@dopomogai/types';
import { handleApiError } from '../utils/handleApiError';

export type VisitorConversationSummary = {
  id: string;
  agent_id: string;
  agent_name?: string | null;
  first_user_message_preview?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
};

export type VisitorConversationList = {
  items: VisitorConversationSummary[];
  total: number;
};

export const visitorConversationsService = {
  listForVisitor: async (
    rootApiUrl: string,
    versionId: UUID,
    visitorId: string,
    wat: string,
    limit = 10,
    offset = 0
  ): Promise<VisitorConversationList | any> => {
    try {
      const clean = rootApiUrl.endsWith('/') ? rootApiUrl.slice(0, -1) : rootApiUrl;
      const url = new URL(`${clean}/api/v1/widgets/${versionId}/conversations`);
      url.searchParams.set('limit', String(limit));
      url.searchParams.set('offset', String(offset));
      url.searchParams.set('visitor_id', visitorId);

      const res = await fetch(url.toString(), {
        method: 'GET',
        headers: { Authorization: `Bearer ${wat}` },
      });
      if (!res.ok) {
        throw { response: { status: res.status, data: { detail: await res.text().catch(() => res.statusText) } } };
      }
      return await res.json();
    } catch (err) {
      return handleApiError(err, 'listing visitor conversations');
    }
  },

  getOneForVisitor: async (
    rootApiUrl: string,
    versionId: UUID,
    conversationId: string,
    visitorId: string,
    wat: string
  ): Promise<any> => {
    try {
      const clean = rootApiUrl.endsWith('/') ? rootApiUrl.slice(0, -1) : rootApiUrl;
      const url = new URL(`${clean}/api/v1/widgets/${versionId}/conversations/${conversationId}`);
      url.searchParams.set('visitor_id', visitorId);

      const res = await fetch(url.toString(), {
        method: 'GET',
        headers: { Authorization: `Bearer ${wat}` },
      });
      if (!res.ok) {
        throw { response: { status: res.status, data: { detail: await res.text().catch(() => res.statusText) } } };
      }
      return await res.json();
    } catch (err) {
      return handleApiError(err, `fetching visitor conversation ${conversationId}`);
    }
  },
};
